import React, { useEffect, useState } from 'react'
import { useQuery } from '@apollo/client';
import { getAssociationPublicQuery } from '../../../../queries/association';
import { FaRegCopy } from 'react-icons/fa';

export const BookletSelectedCompanyItem = ({ booklet }) => {
  const { data: associationData } = useQuery(getAssociationPublicQuery, {
    variables: { associationId: booklet?.mainAssociationId },
    skip: !booklet?.mainAssociationId
  });

  const [isCodeCopied, setIsCodeCopied] = useState(false);

  const copyCode = () => {
    navigator.clipboard.writeText(webshopUrl);
    setIsCodeCopied(true);
  };

  useEffect(() => {
    if (isCodeCopied) {
      const timer = setTimeout(() => {
        setIsCodeCopied(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [isCodeCopied]);

  const association = associationData?.association;
  const webshopUrl = association?.slug && association?.shopShareDomain
    ? `${association.shopShareDomain.startsWith('http') ? '' : 'https://'}${association.shopShareDomain}/${association.slug}`
    : undefined;

  return (
    <div className='company-item'>
      <div className='company-item-content'>
        <small>{booklet.title}</small>
        {webshopUrl && (
          <button title="Kopiera shopaddress" className='secondary xs' onClick={copyCode}>
            {isCodeCopied ? (
              'Kopierat ✓'
            ) : (
              <>
                Shop-URL <FaRegCopy size={10} />
              </>
            )}
          </button>

        )}
      </div>
    </div>
  )
}

